export const REPORTS_API = (COMMUNITY_ID: string) => `v1/community/${COMMUNITY_ID}/invoice/report`;
export const AR_REPORTS_API = (COMMUNITY_ID: string) => `v1/community/${COMMUNITY_ID}/reports/ar-360`;
export const TRIAL_BALANCE_REPORT_API = (COMMUNITY_ID: string) => `v1/community/${COMMUNITY_ID}/reports/trial-balance`;
export const VENDOR_BALANCE_API = (COMMUNITY_ID: string) => `v1/community/${COMMUNITY_ID}/reports/vendor-balance`;
export const PROPERTY_REPORT = `v1/reports/property`;
export const OWNER_REPORT = `v1/reports/owners`;